<template>
    <div class="container-fluid">
        <!-- HEADER -->
        <div class="view-header my-4">
            <div class="view-header__main">
                <div class="view-header__info">
                    <h1 class="view-header__title">Cobranzas</h1>
                    <p class="view-header__subtitle">Gestioná cobros, recibos e imputaciones de la cuenta corriente del cliente.</p>
                </div>
            </div>
        </div>

        <!-- FILTROS -->
        <div class="filters-panel">
            <div class="filters-panel__section">
                <div class="filters-panel__section-title">
                    <i class="bi bi-search"></i>
                    Buscador
                </div>
                <div class="filters-panel__row">
                    <div class="filters-panel__field">
                        <label class="control-label">Cliente</label>
                        <typeahead
                        :name="'client'"
                        :placeh="'Busqueda de cliente por nombre'"
                        :clean-on="false"
                        @choosed="clientUpdate"
                        @empty="clientEmpty"
                        :default="'null'"
                        :externalsrc="'/api/clients/getClients'"
                        limit-chars="4"/>
                    </div>
                    <div class="filters-panel__field">
                        <label class="control-label">Desde</label>
                        <datepicker-component @datechoosed="fromDateUpdated" :dateLabel="'Seleccione una fecha'"/>
                    </div>
                    <div class="filters-panel__field">
                        <label class="control-label">Hasta</label>
                        <datepicker-component @datechoosed="toDateUpdated"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- TABS -->
        <ul class="nav product-tabs">
            <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab == 0 }" href="#" @click.prevent="activeTab = 0">
                    <i class="bi bi-cash-stack"></i> Cobranzas
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab == 1 }" href="#" @click.prevent="activeTab = 1">
                    <i class="bi bi-receipt"></i> Recibos
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab == 2 }" href="#" @click.prevent="activeTab = 2">
                    <i class="bi bi-diagram-3"></i> Imputaciones
                </a>
            </li>
        </ul>

        <!-- PESTAÑA COBRANZAS -->
        <template v-if="activeTab == 0">
            <div v-if="payload.header.client_id" class="row">
                <div class="col-md-3">
                    <div class="stats-card">
                        <div class="stats-card__value">{{ balanceText }}</div>
                        <div class="stats-card__label">Saldo en cuenta corriente</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="stats-card">
                        <div class="stats-card__value" :class="{ 'stats-card__value--danger': concilValue < 0 }">{{ concilText }}</div>
                        <div class="stats-card__label">Conciliación</div>
                    </div>
                </div>
                <div class="col-md-3 d-flex align-items-center">
                    <div class="w-100">
                        <label class="control-label d-block mb-1" style="font-size: 12px; font-weight: 600;">Comprobantes</label>
                        <select v-model="posFilter" class="form-control" name="posFilter">
                            <option :value="0">Todos los comprobantes</option>
                            <option :value="1">Comprobantes de prueba</option>
                            <option :value="2">Comprobantes oficiales</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3 d-flex align-items-center justify-content-center">
                    <label class="d-inline-flex align-items-center mb-0" style="gap: 8px; cursor: pointer;">
                        <input type="checkbox" v-model="historical">
                        <span>Mostrar histórico</span>
                    </label>
                </div>
            </div>
            <div v-else class="stats-card">
                <div class="stats-card__label">Buscá un cliente para ver la información</div>
            </div>

            <!-- TOOLBAR -->
            <div class="d-flex justify-content-end mb-3" style="gap: 8px;">
                <button type="button" class="btn view-header__btn" @click="showModalRet = true">
                    <i class="bi bi-percent"></i>
                    Pasar retención
                </button>
                <button type="button" id="allocation-btn" class="btn view-header__btn" @click="checkAllocations()">
                    <i class="bi bi-link-45deg"></i>
                    Imputar
                </button>
                <button type="button" class="btn view-header__btn view-header__btn--primary" :disabled="!payload.header.client_id" @click="ifModalPayment()">
                    <i class="bi bi-plus-lg"></i>
                    Nuevo cobro
                </button>
            </div>

            <div class="row">
                <!-- FACTURAS -->
                <div class="col-md-6">
                    <div v-if="tableDocFields.length > 0" class="mb-2">
                        <input v-model="docFilter" class="form-control" placeholder="Buscar por factura...">
                    </div>
                    <div class="data-table">
                        <div class="table-responsive">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th><input type="checkbox" v-model="selectAllDocs"></th>
                                        <th>Fecha</th>
                                        <th>Factura</th>
                                        <th class="text-right">Deuda</th>
                                        <th class="text-right">Saldo</th>
                                        <th class="text-right">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(doc, index) in tableDocFieldsFiltered" :key="index" :class="[{ selected: doc.rowSelected }, { rojo: doc.payment }, { azul: doc.historical }]">
                                        <td>
                                            <input type="checkbox" v-model="selectedDocs" :value="doc" @click="selectRow($event, doc)">
                                        </td>
                                        <td>{{ doc.date }}</td>
                                        <td>{{ doc.docname }}</td>
                                        <td class="text-right">$ {{ parseFloat(doc.value).toFixed(2) }}</td>
                                        <td class="text-right">$ {{ parseFloat(doc.debt).toFixed(2) }}</td>
                                        <td class="text-right">
                                            <div v-if="doc.docname != 'SALDO INICIAL'" class="table-action-group">
                                                <router-link class="table-action-btn" :to="'/ventas/index/detalle/' + doc.sale_id" title="Ver detalle">
                                                    <i class="bi bi-eye"></i>
                                                </router-link>
                                                <button type="button" class="table-action-btn" title="Anular comprobante" @click="cancelInvoice(doc.sale_id)">
                                                    <i class="bi bi-x-circle"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="tableDocFieldsFiltered.length === 0">
                                        <td colspan="6" class="data-table__empty">Sin comprobantes para mostrar</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- RECIBOS -->
                <div class="col-md-6">
                    <div v-if="tablePayFields.length > 0" class="mb-2">
                        <input v-model="payFilter" class="form-control" placeholder="Buscar por recibo...">
                    </div>
                    <div class="data-table">
                        <div class="table-responsive">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th><input type="checkbox" v-model="selectAllPays"></th>
                                        <th>Fecha</th>
                                        <th>Recibo</th>
                                        <th class="text-right">Valor</th>
                                        <th class="text-right">Saldo</th>
                                        <th class="text-right">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(rec, index) in tablePayFieldsFiltered" :key="index" :class="[{ selected: rec.rowSelected }, { azul: rec.historical }]">
                                        <td>
                                            <input type="checkbox" v-model="selectedPays" :value="rec" @click="selectRow($event, rec)">
                                        </td>
                                        <td>{{ rec.date }}</td>
                                        <td>{{ rec.receipt }}</td>
                                        <td class="text-right">$ {{ parseFloat(rec.value).toFixed(2) }}</td>
                                        <td class="text-right">$ {{ parseFloat(rec.rest).toFixed(2) }}</td>
                                        <td class="text-right">
                                            <div class="table-action-group">
                                                <a class="table-action-btn" :href="'/ventas/cobranzas/detalle-recibo/' + rec.id" title="Ver detalle">
                                                    <i class="bi bi-eye"></i>
                                                </a>
                                                <button type="button" class="table-action-btn" title="Cancelar pago" @click="cancelPayment(rec.id)">
                                                    <i class="bi bi-x-circle"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="tablePayFieldsFiltered.length === 0">
                                        <td colspan="6" class="data-table__empty">Sin recibos para mostrar</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- PESTAÑA RECIBOS -->
        <receipts-table
        v-if="activeTab == 1"
        :client="payload.header.client_id"
        :fromDate="fromDate"
        :toDate="toDate"
        :watchTarget="tablePayFields"
        @cancelPay="cancelPayment"/>

        <!-- PESTAÑA IMPUTACIONES -->
        <allocations-table
        v-if="activeTab == 2"
        @allocationDeleted="refreshTables"
        :client="payload.header.client_id"
        :fromDate="fromDate"
        :toDate="toDate"/>

        <receipt-payment-methods
        v-bind:header="payload.header"
        :fundDefault="config.fund_id"
        @paymentmethodschanged="paymentMethodsUpdated"
        @paymentmethodsclose="paymentMethodsClose"
        @close="closeModal"
        @comissionUpdated="comDataUpdate"
        v-bind:total="concilValue"
        v-bind:paymentMethods="payment_methods"
        v-if="showModal"
        :limited="false"
        :fromCC="true"/>

        <earnings-withholding
        v-if="showModalRet"
        :client_id="payload.header.client_id"
        :limited="false"
        :fromCC="true"
        :selectedDocs="selectedDocs"
        @updated="withholdingNew"
        @close="showModalRet = false"/>

    </div>
</template>

<script>

import receiptPaymentMethods from '../../paymentmethods/Receipt-payment-methods.vue';
import earningsWithholding from '../../paymentmethods/Earnings-withholding.vue';

import typeahead from '../../global/Typeahead.vue';
import datepickerComponent from '../../global/Datepicker-empty.vue';

import receiptsTable from './ReceiptList.vue';
import allocationsTable from './Allocations.vue';
import { mapState } from 'vuex'

export default {
  props: ['endpointurl'],
  data() {
    return {
      activeTab: 0,
      showModal: false,
      showModalRet: false,
      payload: {
        header: {
          client_id : null,
          posId: 0,
          pos: 0,
          service_fromdate:'',
          letter:''
        },
        paymentMethods: []
      },
      comissionData: {},
      fromDate: null,
      toDate:null,
      historical: null,
      posFilter:0,
      concilValue: 0.00,
      balanceValue:0.00,
      tableDocFields:[],
      tablePayFields:[],
      selectedDocs:[],
      selectedPays:[],
      docFilter:'',
      payFilter:'',
      printURL:'',
      payment_methods:{
        cuenta_corriente:0
      }
    }
  },
  created () {
    this.$store.dispatch('authUser/getAuthUser')
  },
  mounted() {
    this.payment_methods.cuenta_corriente=0;
    this.historical=false;
    this.testDocs=true;
  },
  methods: {
    SwitchTab() {
        this.activeTab = 1
    },
    fromDateUpdated: function (date) {
      this.fromDate = date;
      this.refreshTables();
    },
    toDateUpdated: function (date) {
      this.toDate = date;
      this.refreshTables();
    },
    paymentMethodsUpdated(obj) {
        this.payload.paymentMethods=obj;
    },
    paymentMethodsClose(obj) {
        this.payload.paymentMethods=obj;
        // banks siempre trae al menos un slot ({amount: 0}), por eso miramos el monto, no el length.
        var hasTransfer = Array.isArray(obj.banks) && obj.banks.some(b => Number(b.amount) > 0);
        if ((obj.cash >0) || (obj.accounts.length>0) || (obj.creditcards.length>0) || (obj.tpchecks.length>0) || (obj.discount>0) || hasTransfer){
            this.sendReceipt();
        }
    },
    withholdingNew(obj){
        this.$http.post('/api/clients/addEarningsWithholding', obj)
        .then((response) => {
            if (response.data.success) {
                alert("Se grabo correctamente la retencion de ganancias");
            } else {
                alert("Hubo un error grabando la retencion de ganancias");
            }
            }).catch((error) => {
            console.log('error: '+error);
        })
    },
    sendReceipt() {
      var vm= this;
      var outdata = {
          'header': vm.payload.header,
          'paymentMethods' :vm.payload.paymentMethods,
          'selectedDocs' : vm.selectedDocs,
          'selectedPay' : vm.selectedPays,
          'comissionData' : vm.comissionData
        };
      this.concilValue = 0.00;
      this.$http.post('/api/collections/addAllocationPayment', outdata)
          .then((response) => {
            
            if (response.data.success) {
                if (response.data.data.printInvoice == true) {
                    if (response.data.data.printReceiptTicket) {
                        window.location.href = '/cobranzas/ticket/'+response.data.data.ID;
                    }else {
                        window.open(response.data.data.urlInvoice, '_blank');
                    }
              } else {
                // no-op intencional
                
              }
              this.updateBalanceValue();
              this.refreshTables();
            } else {
              // no-op intencional
              
            }
          }).catch((error) => {
            console.log('error: '+error);
          })
    },
    selectRow(event, item) {
        item.rowSelected = !item.rowSelected;
    },
    clientUpdate(data) {
       
      this.payload.header.client_id=data.id;
      this.updateBalanceValue();
      this.refreshTables();
      this.selectedDocs=[];
      this.selectedPays=[];
    },
    clientEmpty(){
        this.payload.header.client_id=null;
        this.refreshTables();
        this.selectedDocs=[];
        this.selectedPays=[];
    },
    getclientList(){
        var vm = this;
        this.$http.get('/api/clients/list')
            .then(response => {
              if(response.data) {
                vm.clientList = response.data.data;
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    refreshTables(){
        var vm= this;
        var outdata = {
            'client_id': vm.payload.header.client_id,
            'historical' : vm.historical,
            'posFilter':vm.posFilter,
            'fromDate':vm.fromDate,
            'toDate':vm.toDate
        };
        this.$http.post('/api/collections/getListInvoices', outdata)
            .then(response => {
              if(response.data) {
                vm.tableDocFields = response.data;
              }
            })
            .catch(error => {
              alert(error);
            })

        this.$http.post('/api/collections/getListReceipts', outdata)
            .then(response => {
              if(response.data) {
                vm.tablePayFields = response.data;
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    updateConcilValue(){
        var vm=this;
        var outdata ={
            'client': vm.payload.header.client_id,
            'selectedDocs' : vm.selectedDocs,
            'selectedPay' : vm.selectedPays
        };

        this.$http.post('/api/collections/getConciliation', outdata)
            .then(response => {
              if(response.data.data) {
                vm.concilValue = parseFloat(response.data.data);
              }else{
                vm.concilValue = 0.00;
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    updateBalanceValue(){
        var vm=this;
        this.$http.get('/api/clients/getBalance/' +  vm.payload.header.client_id)
            .then(response => {
              if(response.data.data) {
                vm.balanceValue = parseFloat(response.data.data);
              }else{
                vm.balanceValue = 0.00;
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    checkAllocations(){
        if (this.selectedDocs.length<=0){
            alert("Necesita seleccionar comprobantes");
            return false;
        }

        if (confirm("Se realizará la imputación indicada")){
            if (this.concilValue>0){
                if(confirm("El pago no es suficiente para cubrir los comprobantes seleccionados ¿Desea ingresar un pago por el monto restante ahora?")){
                    this.showModal = true;
                }else{
                    this.allocate();
                }
            }else{
                this.allocate();
            }
        }
    },
    allocate(){
        var vm=this;
        var outdata ={
            'client': vm.payload.header.client_id,
            'selectedDocs' : vm.selectedDocs,
            'selectedPay' : vm.selectedPays
        };

        this.$http.post('/api/collections/addAllocation', outdata)
            .then(response => {
              if(response.data.success) {
                  this.refreshTables();
              }else{
                // no-op intencional
                  
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    ifModalPayment(){
        if (this.concilValue>=0){ this.showModal = true;
        }else{ alert("No se pueden crear pagos con valor negativo");}
    },
    cancelPayment(data){
        if (confirm("¿Está seguro que desea eliminar este comprobante? Se desarmarán también todas las imputaciones en las que se encuentre asociado")){
            this.$http.get('/api/collections/cancelPayment/'+data)
            .then(response => {
                if(response.data.success) {
                  this.refreshTables();
                }else{
                  alert(response.message);
                }
            })
            .catch(error => {
              alert(error.message);
            })
        }
    },
    cancelInvoice(id){
        if (confirm("¿Está seguro que desea anular este comprobante? No aparecerá en el listado de cobranzas pero podrá verse en la vista de ventas")){
            this.$http.post('/api/sales/cancel/'+id)
            .then(response => {
                if(response.data.success) {
                  this.refreshTables();
                }else{
                  alert(response.message);
                }
            })
            .catch(error => {
              alert(error.message);
            })
        }
    },
    comDataUpdate(obj){
        this.comissionData=obj;
    },
    closeModal() {
      this.showModal = false;
      //window.location.href = window.location.pathname;
    },
  },
  computed: {
    ...mapState('authUser',{
        authUser: state => state.authUser,
    }),
    
    config: {
            get: function () { return this.authUser.branchoffices[0].configs;}
        },
   
    selectAllDocs: {
        get: function () {
            if((this.selectedDocs.length == this.tableDocFields.length) && (this.tableDocFields.length!=0)){
                return true;
            }else{
                return false;
            }
        },
        set: function (value) {
            var selected = [];

            if (value) {
                for (var doc in this.tableDocFields) {
                    this.tableDocFields[doc].rowSelected =true;
                    this.selectedDocs.push(this.tableDocFields[doc]);
                }
            }else{
                for (doc in this.tableDocFields) {
                    this.tableDocFields[doc].rowSelected =false;
                }
                this.selectedDocs = selected;
            }
        }
    },
    selectAllPays: {
        get: function () {
            if ((this.selectedPays.length == this.tablePayFields.length) && (this.tablePayFields.length!=0)){
                return true;
            }else{
                return false;
            }
        },
        set: function (value) {
            var selected = [];

            if (value) {
                for (var pay in this.tablePayFields) {
                    this.tablePayFields[pay].rowSelected =true;
                    this.selectedPays.push(this.tablePayFields[pay]);
                }
            }else{
                for (pay in this.tablePayFields) {
                    this.tablePayFields[pay].rowSelected =false;
                }
                this.selectedPays=selected;
            }
        }
    },
    concilText: {
        get: function () {
            return '$ ' + this.concilValue.toFixed(2).replace(".",",").replace(/\d(?=(\d{3})+,)/g, '$&.');
        }
    },
    balanceText: {
        get: function () {
            return '$ ' + this.balanceValue.toFixed(2).replace(".",",").replace(/\d(?=(\d{3})+,)/g, '$&.');
        }
    },
    tableDocFieldsFiltered:{
        get: function () {
            let vm = this;
            return this.tableDocFields.filter(e => e.docname.includes(vm.docFilter));
        }
    },
    tablePayFieldsFiltered:{
        get: function () {
            let vm = this;
            return this.tablePayFields.filter(e => e.receipt.includes(vm.payFilter));
        }
    }
},
  watch: {
    authUser: {
          handler: function () {
            this.payment_methods = { ...this.authUser.branchoffices[0].payments_methods}
            this.payment_methods.cuenta_corriente = 0;
        },
      },
      'selectedDocs': {
          handler: function () {this.updateConcilValue();}
      },
      'selectedPays': {
          handler: function () {this.updateConcilValue();}
      },
      'historical': {
          handler: function () {this.refreshTables();}
      },
      'posFilter': {
          handler: function () {this.refreshTables();}
      },
  },
  components: {
    receiptPaymentMethods,
    earningsWithholding,
    typeahead,
    datepickerComponent,
    receiptsTable,
    allocationsTable
  },
}
</script>